import { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import swal from "sweetalert";
import {
  AGGREGATOR_USERS_SAVE,
  GET_ALL_MASTER_MERCHANT_PRIVILAGES,
} from "../../../utils/constant";
import { jwtDecode } from "jwt-decode";
import { getTokenFromLocalStorage } from "../../../utils/tokenService";
import { isEmailIdRegexIsValid } from "../../../utils/helper";
import useApiServices from "../../../utils/useApiServices";

const CreateUser = ({ refetch }) => {
  const [privilagesData, setPrivilagesData] = useState();
  const [privilages, setPrivilages] = useState([]);
  const token = getTokenFromLocalStorage();
  const decodedToken = typeof token === "string" ? jwtDecode(token) : {};
  const { masterId } = decodedToken;
  const { apiCallFnforGet, apiCallFnforPost } = useApiServices();

  const [formDataInputs, setFormDataInputs] = useState({
    userName: "",
    password: "",
    MobileNumber: "",
    emailId: "",
  });

  const getAllMasterMerchantPrivilages = async () => {
    try {
      if (!masterId) return;
      const response = await apiCallFnforGet(
        GET_ALL_MASTER_MERCHANT_PRIVILAGES + masterId
      );
      if (response.statusCode === 200) {
        setPrivilagesData(response?.data || []);
      } else {
        setPrivilagesData([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllMasterMerchantPrivilages();
  }, []);

  const handleformDataInputs = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    if (name === "password" || name === "emailId") {
      setFormDataInputs({ ...formDataInputs, [name]: value });
    } else {
      value = value.toUpperCase();
      if (name === "MobileNumber") {
        // Remove any non-numeric characters
        value = value.replace(/\D/g, "");
      }
      setFormDataInputs({ ...formDataInputs, [name]: value });
    }
  };

  const handleSelectPrivilege = (e) => {
    const id = String(e.target.name);

    setPrivilages((prev) => {
      if (e?.target?.checked) {
        if (!prev.includes(id)) return [...prev, id];
        return prev;
      } else {
        return prev.filter((p) => p !== id);
      }
    });
  };

  const handleSelectAllPrivileges = (subList, isChecked) => {
    const ids = subList?.map((sub) => String(sub?.adminPrivilegeSubTypeId));

    setPrivilages((prev) => {
      if (isChecked) {
        const merged = new Set([...prev, ...ids]);
        return [...merged];
      } else {
        return prev.filter((p) => !ids.includes(p));
      }
    });
  };

  const handleSubmit = async (e) => {
    if (formDataInputs.userName === "") {
      swal({
        title: "Alert!",
        text: "Please Enter User Name",
        icon: "error",
      });
      return;
    }
    if (formDataInputs.MobileNumber === "") {
      swal({
        title: "Alert!",
        text: "Please Enter Mobile Number",
        icon: "error",
      });
      return;
    }

    if (formDataInputs.emailId === "") {
      swal({
        title: "Alert!",
        text: "Please Enter Email Id",
        icon: "error",
      });
      return;
    }
    if (!privilages.length) {
      swal({
        title: "Alert!",
        text: "Please select atleast one privilage",
        icon: "error",
      });
      return;
    }
    if (!isEmailIdRegexIsValid(formDataInputs.emailId)) {
      swal({
        title: "Alert!",
        text: "Please Enter Valid Merchant E-Mail ID !",
        icon: "error",
      }).then(() => {
        setFormDataInputs({ ...formDataInputs });
      });
      return;
    }
    const privilegs = privilages?.map((item) => {
      return parseInt(item);
    });

    const payload = {
      email: formDataInputs.emailId.trim(),
      masterMerchantId: masterId,
      mobile: formDataInputs.MobileNumber.trim(),
      name: formDataInputs.userName.trim(),
      password: formDataInputs.password.trim(),
      privilegeId: privilegs,
    };

    e.preventDefault();
    // return;
    const swalConfirm = await swal({
      title: "Are you sure?",
      text: "Do you want to submit the application?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });
    if (swalConfirm) {
      const res = await apiCallFnforPost(AGGREGATOR_USERS_SAVE, payload);

      if (res?.statusCode === 200) {
        swal({
          title: "Success",
          text: "User Saved Successfully.",
          icon: "success",
        });
        refetch();
        setFormDataInputs({
          userName: "",
          password: "",
          MobileNumber: "",
          emailId: "",
        });
        setPrivilages([]);
        setPrivilagesData([]);
      } else {
        swal({
          title: "Failed",
          text: res.message,
          icon: "error",
        });
      }
    }
  };

  const handleValidations = (e) => {
    if (e.target.name === "email" && e.target.value !== "") {
      if (!isEmailIdRegexIsValid(formDataInputs.emailId)) {
        swal({
          title: "Alert!",
          text: "Please Enter Valid Merchant E-Mail ID !",
          icon: "error",
        }).then(() => {
          formDataInputs({ ...formDataInputs, email: "" });
        });
        return;
      }
    }
  };

  return (
    <div class="row">
      <div class="col-12">
        {/* <div className="card input-box-shadow"> */}
        <div className="card-header">
          <h4 className="card-title">Fill Master Merchant Details</h4>
        </div>
        <div className="card-body py-4">
          <div id="" className="form-wizard order-create">
            <div id="" className="tab-pane" role="tabpanel">
              <form className="form-section-form-group">
                <div className="row">
                  <div className="col-lg-6 mb-2">
                    <div className="mb-3">
                      <label className="mb-1 text-dark fs-4">
                        Name
                        <sup className="text-danger">*</sup>
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        name="userName"
                        value={formDataInputs.userName}
                        onChange={handleformDataInputs}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 mb-2">
                    <div className="mb-3">
                      <label className="mb-1 text-dark fs-4">
                        e-Mail Id
                        <sup className="text-danger">*</sup>
                      </label>

                      <input
                        type="email"
                        className="form-control"
                        name="emailId"
                        value={formDataInputs.emailId}
                        onChange={handleformDataInputs}
                        onBlur={handleValidations}
                      />
                    </div>
                  </div>
                  {/* ./form-group */}

                  <div className="col-lg-6 mb-2">
                    <div className="mb-3">
                      <label className="mb-1 text-dark fs-4">
                        Mobile Number
                        <sup className="text-danger">*</sup>{" "}
                      </label>

                      <input
                        className="form-control"
                        maxLength={10}
                        minLength={10}
                        name="MobileNumber"
                        value={formDataInputs.MobileNumber}
                        onChange={handleformDataInputs}
                        required
                        pattern="[0-9]{10}"
                        title="Please enter a 10-digit mobile number"
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 mb-2">
                    <div className="mb-3">
                      <label className="mb-1 text-dark fs-4">
                        Password
                        <sup className="text-danger">*</sup>
                      </label>
                      <input
                        className="form-control"
                        name="password"
                        value={formDataInputs.password}
                        onChange={handleformDataInputs}
                      />
                    </div>
                  </div>
                  {/* ./form-group */}

                  <div className="card-header">
                    <h4 className="card-title">Privileges</h4>
                  </div>

                  <Row className="mt-3">
                    <div className="d-flex flex-column gap-4">
                      {privilagesData &&
                        privilagesData
                          .filter(
                            (priv) =>
                              priv?.data?.privilegeName !== "Tools User Management"
                          )
                          ?.map((group, i) => (
                            <div key={i} className="d-flex flex-column">
                              {/* PARENT SELECT ALL */}
                              <div className="d-flex justify-content-start align-items-center gap-2">
                                <div className="checkbox-wrapper-31">
                                  <input
                                    type="checkbox"
                                    checked={group?.data?.subTypeDtoList.every(
                                      (sub) =>
                                        privilages.includes(
                                          String(sub.adminPrivilegeSubTypeId)
                                        )
                                    )}
                                    ref={(el) => {
                                      if (!el) return;
                                      const any =
                                        group?.data?.subTypeDtoList.some(
                                          (sub) =>
                                            privilages.includes(
                                              String(
                                                sub.adminPrivilegeSubTypeId
                                              )
                                            )
                                        );
                                      const all =
                                        group?.data?.subTypeDtoList.every(
                                          (sub) =>
                                            privilages.includes(
                                              String(
                                                sub.adminPrivilegeSubTypeId
                                              )
                                            )
                                        );
                                      el.indeterminate = any && !all;
                                    }}
                                    onChange={(e) =>
                                      handleSelectAllPrivileges(
                                        group?.data?.subTypeDtoList,
                                        e.target.checked
                                      )
                                    }
                                  />
                                  <svg viewBox="0 0 35.6 35.6">
                                    <circle
                                      class="background"
                                      cx="17.8"
                                      cy="17.8"
                                      r="17.8"
                                    ></circle>
                                    <circle
                                      class="stroke"
                                      cx="17.8"
                                      cy="17.8"
                                      r="14.37"
                                    ></circle>
                                    <polyline
                                      class="check"
                                      points="11.78 18.12 15.55 22.23 25.17 12.87"
                                    ></polyline>
                                  </svg>
                                </div>
                                <h1 className="pt-2">
                                  {group?.data?.privilegeName}
                                </h1>
                              </div>

                              {/* SUB PRIVILEGES */}
                              <div className="row fs-4 mt-2 text-dark">
                                {group?.data?.subTypeDtoList?.map((sub, j) => (
                                  <div
                                    key={j}
                                    className="checkbox-wrapper-27 col-lg-4 col-md-6 col-sm-12 d-flex"
                                  >
                                    <label className="checkbox">
                                      <input
                                        type="checkbox"
                                        name={sub?.adminPrivilegeSubTypeId}
                                        checked={privilages.includes(
                                          String(sub?.adminPrivilegeSubTypeId)
                                        )}
                                        onChange={handleSelectPrivilege}
                                      />
                                      <span className="checkbox__icon"></span>
                                      {sub?.subTypePrivilegeName}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                    </div>
                  </Row>
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      className="badge badge-rounded badge-primary mx-2 px-3 py-3"
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateUser;
